<script>
    import { translateText } from 'lang'
    import {executeClientToGroup, executeClientAsyncToGroup} from "api/rage";
    import Access from '../access/index.svelte'
    import { setPopup } from '../../data'
    import { addListernEvent } from "api/functions";

    let ranks = []

    const loadRanks = (keepSelected = false) => {
        executeClientAsyncToGroup("getRanks").then((result) => {
            if (result && typeof result === "string") {
                ranks = JSON.parse(result);

                if (!keepSelected && ranks[0])
                    onSelectId (ranks[0])
            }
        });
    }
    loadRanks();

    // сервер после переименования присылает новый список рангов
    addListernEvent ("table.ranks", () => loadRanks(true))

    let isLeader = false;
    executeClientAsyncToGroup("getSettings").then((result) => {
        if (result && typeof result === "string") {
            try {
                isLeader = !!JSON.parse(result).isLeader;
            } catch (e) { }
        }
    });

    let selectId = -1;
    const onSelectId = (item) => {
        executeClientToGroup('rankAccessLoad', item.id)
        selectId = item.id;
    }

    // Переименование ранга — только лидеру. Событие штатное (updateRankName):
    // сервер сам проверяет права, длину (до 25 символов) и запрещённые слова.
    const onRename = (item) => {
        setPopup ("LcInput", {
            headerTitle: "Переименование ранга",
            subtitle: `Ранг ${item.id} · сейчас «${item.name}»`,
            input: {
                title: "Новое название",
                placeholder: item.name,
                maxLength: 25,
                value: item.name
            },
            hint: "Название увидят все во фракции: в списке состава, логах и на рации.",
            button: "Сохранить",
            callback: (value) => {
                if (!value || !String(value).trim().length)
                    return;

                executeClientToGroup('updateRankName', item.id, String(value).trim());
            }
        })
    }
</script>
<div class="appmenufrac access">
    <div class="leftacce">
        <h1>Ранги:</h1>
        <div class="listacce">
            {#each ranks as item, index}
                {#if (ranks.length - 1) !== index}
                    <div class="blockacce" class:active={selectId === item.id} on:keypress={() => {}} on:click={() => onSelectId(item)}>
                        <p>{item.id}</p>
                        <b>{item.name}</b>
                        {#if isLeader}
                            <button class="renamebtn" type="button" title="Переименовать ранг"
                                    on:click|stopPropagation={() => onRename(item)}>Переименовать</button>
                        {/if}
                    </div>
                {/if}
            {/each}
        </div>
    </div>
    <div class="rightacce">
            <h1>Права выбранного ранга</h1>
            {#if selectId >= 0}
                <Access
                    itemId={selectId}
                    executeName="updateRankAccess"
                    isSelector={false}
                    clsScroll="w-399 h-480" />
            {:else}
                <div class="fractions__main_scroll w-399 h-480" />
            {/if}
    </div>
</div>

<style>
    .renamebtn {
        display: inline-flex;
        align-items: center;
        border: 0;
        margin-left: auto;
        padding: 0.4vh 1vh;
        border-radius: 0.37vh;
        background: rgba(231, 174, 63, 0.12);
        color: rgb(231, 174, 63);
        font-family: 'SF Pro Display', sans-serif;
        font-size: 1.1vh;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
    }
    .renamebtn:hover { background: rgba(231, 174, 63, 0.24); }
</style>
